import boxShadowTransformation from "../transformation/boxShadowTransformation";
import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";
export var boxShadow = createStyledEnhancer({
  name: "boxShadow",
  // TODO: Реализовать варианты теней по умолчанию в теме
  transformation: boxShadowTransformation,
  keys: ["shadows"]
});
export var shadows = composeEnhancers(boxShadow);